import React from 'react';
import { Input, Row, Col } from 'antd';

const ControlSearch = ({ controlsData, searchText, setSearchText, setFilteredData }) => {
  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = controlsData.filter((record) => {
      const matchesTitle = record.title?.toLowerCase().includes(value.toLowerCase());
      const matchesDescription = record.description?.toLowerCase().includes(value.toLowerCase());
      //const matchesRisk = record.risk?.toLowerCase().includes(value.toLowerCase());
      const matchesCategory = record.category?.name?.toLowerCase().includes(value.toLowerCase());
      //const matchesType = record.type?.toLowerCase().includes(value.toLowerCase());
      const matchesPriority = record.priority?.name?.toLowerCase().includes(value.toLowerCase());
      const matchesArea = record.area?.name?.toLowerCase().includes(value.toLowerCase());
      const matchesFramework = record.framework?.name?.toLowerCase().includes(value.toLowerCase());
      const matchesOwner = record.owner?.toLowerCase().includes(value.toLowerCase());

      return (
        matchesTitle || 
        matchesDescription || 
        //matchesRisk ||
        matchesCategory ||
        //matchesType ||
        matchesPriority ||
        matchesArea ||
        matchesFramework ||
        matchesOwner
      );
    });

    setFilteredData(filtered); 
  };

  const handleReset = () => {
    setSearchText(''); 
    setFilteredData(controlsData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Controles"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default ControlSearch;